export default {
      id: "close-usage",
      viewBox: "0 0 13 13",
      url: __webpack_public_path__ + "img/icons.df848786.svg#close",
      toString: function () {
        return this.url;
      }
    }